import { each } from 'lodash';
import { userHasRole } from '../../util';

class ChatApi {
    routePrefix = 'chat';
    pubnubListener = null;
    currentNotificationChannel = undefined;
    currentPersonalNotificationChannel = undefined;
    notificationListener = null;
    personalNotificationListener = null;
    refreshListener = null;
    secondaryGlobalListener = null;
    _latestChannelSet = undefined;


    getSubscribableChannels(pub: any, user: User, team: any, cohort: any, teams: any, roleSnapshot: any) {
        let _currentChatContextChannels = [];

        each (this.getChannels(user, cohort, cohort, roleSnapshot), channel => {
            _currentChatContextChannels.push(
                channel.key as string
            );
        });

        each (this.getChannels(user, team, undefined, roleSnapshot), channel => {
            _currentChatContextChannels.push(
                channel.key as string
            );
        });

        each (teams, _team => {
            if (cohort) {
                if (_team.parentID === cohort.id) {
                    each (this.getChannels(user, _team, cohort, roleSnapshot), channel => {
                        _currentChatContextChannels.push(
                            channel.key as string
                        );
                    });
                }
            }
        });

        return _currentChatContextChannels;
    }

    getChannels(user: User, group: any, cohort?: any, roleSnapshot?: any) {
        if (roleSnapshot === undefined) {
            return []
        }

        const {
            isAdministrator,
            isCohortAdmin,
            isInstructor,
            isMentor,
        } = roleSnapshot;

        let isCohortMember = isAdministrator || isCohortAdmin || isInstructor || isMentor;

        let team: any;
        if (group) {
            if (group.type === 'Team') team = group as any;
            if (group.type === 'Cohort') cohort = group as any;
        }

        let items: any[] = [];

        let isMemberOfTeam = team ? userHasRole('*', user, team) : false;
        let isSystemAdmin = userHasRole('SystemAdministrator', user, cohort);

        let useInstructorChat     = false;
        let useInstructorFeedback = false;

        if (team) {
            useInstructorChat = team.isInstructorChatVisible === 1;
            useInstructorFeedback = team.isInstructorFeedbackVisible === 1;
        }

        // Cohort's policies take precedent if they exist
        if (cohort) {
            useInstructorChat = cohort.isInstructorChatVisible === 1;
            useInstructorFeedback = cohort.isInstructorFeedbackVisible === 1;
        }

        if (user) {
            if (cohort) {

                if (cohort.isInstructorGeneralVisible === 1) {
                    if (isInstructor || isCohortAdmin || isSystemAdmin) items.push({key: cohort.id + '-IC', value: 'Instructor General'});
                }

                if (cohort.isGeneralVisible === 1) {
                    if (isMemberOfTeam || isCohortMember || isSystemAdmin) items.push({key: cohort.id + '-GC', value: 'General Channel'});
                }
            }

            if (team) {
                if (isMemberOfTeam) {
                    if (isInstructor === false) {
                        items.push({key: team.id + '-TC', value: 'Team Chat'});
                    }
                }

                if (useInstructorChat) {
                    if (isInstructor || isCohortAdmin || isSystemAdmin) items.push({key: team.id + '-IC', value: 'Instructor Chat'});
                }
                
                if (useInstructorFeedback) {
                    if (isInstructor || isMemberOfTeam || isSystemAdmin) {
                        items.push({key: team.id + '-PF', value: 'Instructor Feedback'});
                    }
                }
                
                if (cohort && (isMemberOfTeam || isCohortMember || isSystemAdmin)) {
                    items.push({key: team.id + '-PE', value: 'Peer Feedback'});
                }
            }
        }

        return items;
    }

}

export let chatApi = new ChatApi();
